<div class="px-3">



    <app-error *ngIf="error" [title]="''"></app-error>

    <div class="row  d-flex">
        <app-app-category (reloadapps)="getCategories()" class="col-12"></app-app-category>
    </div>


    
    <ng-template #addProductModal let-modal>

        <div class="modal-header">
            <h4 class="modal-title">
                <!-- {{ isEdit ? ('SAVE' | translate) : ('DISHES_TR.ADD_DISH' | translate) }} -->
                <app-language-selector [appId]="id" (languageChanged)="addLanguageField()"></app-language-selector>
            </h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>

        <!-- <button type="button" class="close" (click)="closeAddProduct()"><fa-icon [icon]="faXmark"></fa-icon></button> -->
        <div class="modal-body">
            <div class="container  ">
                <div class="row d-flex justify-content-center ">
                    
                        <!-- <app-language-selector [appId]="id" (languageChanged)="addLanguageField()"></app-language-selector> -->
        
                        <div [formGroup]="form">

                            <div formArrayName="titles">
                        
                                <div *ngFor="let item of titles.controls; let i = index" [formGroupName]="i">
                            
                                    <div *ngIf="item.get('language')?.value === selectedLanguage">

                                        <div class="form-floating mt-3">
                                            <input type="text" class="form-control" formControlName="value" placeholder="{{ 'DISHES_TR.TITLE_DISH' | translate }}">
                                            <label for="value">{{ "DISHES_TR.TITLE_DISH" | translate }}</label>
                                        </div>

                                        <div class="form-floating mt-3">
                                            <textarea class="form-control" formControlName="description" placeholder="{{ 'DISHES_TR.DESCRIPTION_DISH' | translate }}"></textarea>
                                            <label for="description">{{ 'DISHES_TR.DESCRIPTION_DISH' | translate }}</label>
                                        </div>


                                        <div formArrayName="ingredients" class="mt-4 mb-3 container">
                                            <div class="row rounded border ig-container mb-3 position-relative" *ngFor="let ingredient of getIngredients(item).controls; let j=index" [formGroupName]="j">
                                                
                                                <div class="col-md-1 d-flex justify-content-center align-items-center">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox" formControlName="check" id="type" checked>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="form-floating">
                                                        <input type="text" class="form-control" formControlName="name" id="j" placeholder="{{'DISHES_TR.ADD_IGREDIENTS' | translate}}">
                                                        <label for="j">{{'DISHES_TR.ADD_IGREDIENTS' | translate}}</label>
                                                    </div>
                                                </div>
                                                
                                                <div class="col-md-2">
                                                    <div class="form-floating">
                                                        <input type="text" class="form-control" formControlName="ig_price" id="ig_price" placeholder="{{'DISHES_TR.PRICE' | translate}}">
                                                        <label for="ig_price">{{'DISHES_TR.PRICE' | translate}}</label>
                                                    </div>
                                                </div>

                                                <div class="col-md-4">
                                                    <div class="d-flex justify-content-center">
                                                        <div class="form-check form-switch">
                                                            <input class="form-check-input" type="checkbox" formControlName="type" id="type" checked>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex justify-content-center disabled-container">
                                                        <button class="btn disabled btn-sm rounded-circle b-25">+</button>
                                                        <div class="type-text">{{ 'DISHES_TR.QUANTITY_LABER' | translate }}</div>
                                                        <button class="btn disabled btn-sm rounded-circle b-25">-</button>
                                                    </div>
                                                </div>
                                                
                                                <button type="button" class="btn btn-danger btn-ig-delete" (click)="removeIngredient(i, j)">
                                                    <i class="fi fi-rr-trash"></i>
                                                </button>

                                            </div>
                                        </div>

                                        <button type="button" class="btn btn-outline-secondary" (click)="addIngredient(i)">
                                            <i class="fi fi-rr-add"></i>
                                            {{ 'DISHES_TR.ADD_IGREDIENTS' | translate }}
                                        </button>
                                    
                                    </div>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <div class="form-floating mt-3">
                                        <select class="form-select" id="cat" formControlName="cat_id">
                                            <option [value]="category.id" *ngFor="let category of categories">
                                                {{ category?.titles?.[selectedLanguage]}}
                                            </option>
                                        </select>
                                        <label for="cat">{{ 'CATEGORY.SELECT_CATEGORY' | translate }}</label>
                                    </div>


                                </div>
                                
                                <div class="col-6">
                                    <div class="form-floating mt-3">
                                        <input type="text" class="form-control" formControlName="price" placeholder="{{'DISHES_TR.PRICE' | translate}}">
                                        <label for="value">{{'DISHES_TR.PRICE' | translate}}</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-floating mt-3">
                                        <input type="text" class="form-control" formControlName="sale" placeholder="{{'DISHES_TR.SALE' | translate}}">
                                        <label for="value">{{'DISHES_TR.SALE' | translate}}</label>
                                    </div>
                                </div>
                            </div>
                    
                            <div class="row mt-3">
                                <app-app-upload-img 
                                    [appId]="this.id" 
                                    [productId]="form.get('id').value"
                                    [imgUrl]="form.get('image').value"
                                    class="w-50"
                                    (productIdGenerated)="onProductIdGenerated($event)">
                                </app-app-upload-img>
                            </div>

                            <button (click)="setShow(form.value)" class="btn btn-lg border">
                                <span *ngIf="showLoad" class="spinner-border spinner-border-sm" role="status" ></span>
                                <i class="fi fi-rr-eye" *ngIf="form.get('show').value && !showLoad"></i>
                                <i class="fi fi-rr-eye-crossed" *ngIf="!form.get('show').value && !showLoad"></i>
                            </button>

                            <button type="button" (click)="createOrUpdate()" class="btn btn-lg btn-primary ms-3 mt-3 mb-3" >
                                <span *ngIf="isProductLoad" class="spinner-border spinner-border-sm" role="status" ></span>
                
                                <span *ngIf="isEdit">{{ 'SAVE' | translate}}</span>
                                <span *ngIf="!isEdit">{{ 'DISHES_TR.ADD_DISH' | translate}}</span>
                            </button>
                        </div>
                </div>
            </div>
        </div>

    </ng-template>



    <div class="row mb-5 pb-5">

        <div class="col-md-4 col-lg-3 col-sm-6 col-6 mb-3" (click)="addNewProduct()">
            <!-- <div class="col-6 col-sm-4 col-md-3 mt-3" > -->
            <div class="card-create">
                    <h2><i class="fi fi-rr-add"></i></h2>
                    <h5>{{ "DISHES_TR.ADD_DISH" | translate }}</h5>
            </div>
            <!-- <app-card [appId]="this.id" [item]="[]"></app-card> -->
        </div>

        <div class="col-md-4 col-lg-3 col-sm-6 col-6 mb-3" *ngIf="load">
            <app-loading-skeleton></app-loading-skeleton>
        </div>

    
        <div class="col-md-4 col-lg-3 col-sm-6 col-6 mb-3"  *ngFor="let item of data">
            <div class="card border" *ngIf="!load" >

                <img 
                    *ngIf="item?.image"
                    [src]="'https://s3.eu-north-1.amazonaws.com/menuload.com' + item?.image"
                    loading="lazy"
                    class="card-img-top cursor-pointer rounded p-2"  (click)="editProduct(item)" alt="..."
                >

                <div class="position-relative h-100 w-100" (click)="editProduct(item)"></div>

                <app-app-upload-img 
                    *ngIf="!item?.image"
                    [appId]="this.id" 
                    [productId]="item.id"
                    [imgUrl]="item.image"
                    class="position-absolute w-50"
                    (productIdGenerated)="onProductIdGenerated($event)">
                </app-app-upload-img>

                <div class="card-body p-0 ps-2 px-2 d-flex w-100 justify-content-between align-items-center mb-1">

                    <div class="cursor-pointer text-overflow" (click)="editProduct(item)">
                        <span *ngIf="!item?.product_name?.[systemLang]">  {{"NO_TITLE" | translate }} </span>
                        <span *ngIf="item?.product_name?.[systemLang]"> {{ item?.product_name?.[systemLang] }}</span>
                    </div>
                   
                    <div class="d-flex ">

                        <button (click)="setShow(item)" class="btn bg-white edit text-muthed">
                            <span *ngIf="showLoad && showLoadid == item.id" class="spinner-border spinner-border-sm" role="status" ></span>
                                <i class="fi fi-rr-eye" *ngIf="item.show && showLoadid !== item.id"></i>
                                <i class="fi fi-rr-eye-crossed" *ngIf="!item.show && showLoadid !== item.id"></i>
                        </button>
                   
                    
                        <button class="btn bg-white delete text-danger "  (click)="deleteProduct(item?.id)">
                            <span *ngIf="deleteLoad && item.id == deleteLoadid" class="spinner-border spinner-border-sm" role="status" ></span>
                            <i *ngIf="!deleteLoad || item.id !== deleteLoadid" class="fi fi-rr-trash"></i>
                        </button>
                    </div>
                 
                </div> 
            </div>
            
        </div>
    </div>

 <!-- <app-card [item]="item" [appId]="this.id"></app-card> -->
    
</div>